export default __webpack_public_path__ + "static/media/todo.ad76327b.jpeg";